"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PlusButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const BigButton_1 = __importDefault(require("../../component/GradientButton/BigButton"));
function PlusButton() {
    return ((0, jsx_runtime_1.jsx)(BigButton_1.default, { containerStyle: styles.buttonContainer, style: styles.button, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faPlusLarge, color: "white", size: 20 }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    button: {
        paddingHorizontal: 16,
    },
    buttonContainer: {
        position: 'absolute',
        bottom: 32,
        right: 32,
    },
});
